unit Produtos;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.REST, WEBLib.JSON, WEBLib.CDS,
  WEBLib.Actions, WEBLib.Devices, WEBLib.JQCtrls, WEBLib.ExtCtrls,
  Vcl.Imaging.pngimage, WEBLib.Buttons, WEBLib.ComCtrls;


type
  TuProdutos = class(TForm)
    WebConn: TClientConnection;
    WebDTS: TDataSource;
    WebConnPages: TClientConnection;
    WebDTSPages: TDataSource;
    WebDSPages: TClientDataSet;
    WebDSPagesnpages: TIntegerField;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    CloseData: TButton;
    RS: TEdit;
    NPages: TDBEdit;
    WebLabel4: TLabel;
    Page: TEdit;
    WebLabel3: TLabel;
    Criterio: TEdit;
    Campos: TComboBox;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    mDescr: TDBMemo;
    mProdEan13: TDBEdit;
    mProduto: TDBEdit;
    mGestao: TDBEdit;
    mIdMain: TDBEdit;
    WebLabel8: TLabel;
    WebLabel7: TLabel;
    WebLabel6: TLabel;
    WebLabel5: TLabel;
    WebLabel2: TLabel;
    WebPanel4: TPanel;
    WebDBGrid1: TDBGrid;
    btnPesquisar: TBitBtn;
    PRV: TBitBtn;
    NXT: TBitBtn;
    upProdutos: THttpRequest;
    mIdProd: TDBEdit;
    UnMark: TBitBtn;
    mDesenho: TDBEdit;
    WebLabel9: TLabel;
    mObs: TDBEdit;
    WebLabel10: TLabel;
    Nav01: TDBNavigator;
    Msg01: TMessageDlg;
    mUnd: TDBEdit;
    WebLabel11: TLabel;
    WebClientDS: TClientDataSet;
    WebClientDSidprod: TIntegerField;
    WebClientDSgestao: TIntegerField;
    WebClientDSproduto: TStringField;
    WebClientDSdescr: TStringField;
    WebClientDSund: TStringField;
    WebClientDSdesenho: TStringField;
    WebClientDSprodean13: TStringField;
    WebClientDSobs: TStringField;
    WebClientDSidmain: TIntegerField;
    btnExcluir: TBitBtn;
    procedure WebFormHashChange(Sender: TObject; oldURL, newURL: string);
    procedure CloseDataClick(Sender: TObject);
    [async] procedure btnPesquisarClick(Sender: TObject); async;
    [async] procedure PageKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState); async;
    [async] procedure NXTClick(Sender: TObject); async;
    [async] procedure PRVClick(Sender: TObject); async;
    [async] procedure CriterioChange(Sender: TObject); async;
    procedure CriterioKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure CamposChange(Sender: TObject);
    procedure WebDBGrid1GetCellEditor(Sender: TObject; ACol, ARow: Integer;
      var AEditor: TGridCellEditor);
    procedure WebClientDSBeforePost(DataSet: TDataSet);
    procedure WebDBGrid1KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    [async] procedure Nav01Post(Sender: TObject); async;
    [async] procedure UnMarkClick(Sender: TObject); async;
    procedure btnExcluirClick(Sender: TObject);
    procedure mProdutoKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure mProdEan13KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure mDesenhoKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    [async]

  private
        { Private declarations }
        xCol, xRow: integer;
        xJSON: string;
        procedure AfterEdit;
  public

  protected procedure LoadDFMValues; override; end;



var
  uProdutos: TuProdutos;

implementation


{$R *.dfm}

uses
  uFrmMain;

const
  TOTAL_USERS = 1000;

procedure TuProdutos.AfterEdit;
begin
    //Montando o JSON
    xJSON:=
    '{"produto": "' + mProduto.Text + '",'+
    '"descr": "' + mDescr.Text + '",'+          //Retirar caracteres especiais " e ENTER
    '"desenho": "' + mDesenho.Text + '",'+
    '"gestao": ' + mGestao.Text + ','+
    '"idmain": ' + mIdMain.Text + ','+
    '"obs": "' + mObs.Text + '",'+
    '"prodean": "' + mProdEan13.Text + '",'+
    '"und": "' + mUnd.Text + '"}';
end;

procedure TuProdutos.CriterioChange(Sender: TObject);
begin
    CloseDataClick(Self);
end;

procedure TuProdutos.CriterioKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
        if (Key = VK_F2) or (Key = VK_F3) or (Key= VK_RETURN) then Begin
        //  Pesquisa Municípios
            Criterio.SelectAll;
            Criterio.SetFocus;

            btnPesquisarClick(Self);
        End;
end;

procedure TuProdutos.mDesenhoKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    if Key = VK_TAB then begin
        mUnd.SetFocus;
        mUnd.SelectAll;
    end;
end;

procedure TuProdutos.mProdEan13KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    if Key = VK_F3 then begin

        mDesenho.SetFocus;
        mDesenho.SelectAll;
    end;
end;

procedure TuProdutos.mProdutoKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    //Não funciona os eventos de tecla ! (13/01/2025)
    //(Key = VK_TAB) or
    if (Key = VK_F3) then begin
        UnMark.Caption:= 'xxxxx';
        mProdEan13.SetFocus;
        mProdEan13.SelectAll;
    End;
end;

procedure TuProdutos.Nav01Post(Sender: TObject);
begin
    AfterEdit;

    if (mIdProd.Text <> '') and (WebClientDS.State  in [dsedit]) then
    begin


        //if WebClientDS.State  in [dsedit] then
        //begin

        //end;

        //upProdutos.URL := 'produtos/' + mIdProd.Text;
        upProdutos.URL := FrmMain.BaseURL + 'produtos/' + mIdProd.Text;
        upProdutos.Command := httpPUT;
        upProdutos.Headers.Clear;
        upProdutos.Headers.AddPair('Content-Type','application/json');
        upProdutos.Headers.AddPair('Accept','application/json, text/plain, */*');
        upProdutos.PostData := xJSON;
        upProdutos.Execute();
    end;

    if (WebClientDS.State  in [dsinsert]) then
    begin

        //upProdutos.URL := 'produtos';
        upProdutos.URL := FrmMain.BaseURL + 'produtos';

        upProdutos.Command := httpPOST;
        upProdutos.Headers.Clear;
        upProdutos.Headers.AddPair('Content-Type','application/json');
        upProdutos.Headers.AddPair('Accept','application/json, text/plain, */*');
        upProdutos.PostData := xJSON;
        upProdutos.Execute();
    end;
end;

procedure TuProdutos.NXTClick(Sender: TObject);
begin
    if Page.Text <> '' then
    begin
        if StrToInt(Page.Text)<StrToInt(NPages.Text) then
        begin
            Page.Text:= IntToStr(StrToInt(Page.Text)+1);
            btnPesquisarClick(Self);  //Somente quando existe mudanças
        end;

    end else begin
        Page.Text:= NPages.Text;
        btnPesquisarClick(Self);  //Somente quando existe mudanças
    end;
    Page.SelectAll;
end;

procedure TuProdutos.PageKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
        if (Key = VK_F2) or (Key = VK_F3) or (Key= VK_RETURN) then Begin

            if NPages.Text = '' then
            begin
            //Sem NPages (Até 10 páginas)
                if StrToInt(Page.Text)>=10 then
                begin
                    Page.Text:= '10';
                end;
            end else begin
            //Com NPages (Verifica limites)
                if StrToInt(Page.Text)>StrToInt(NPages.Text) then
                begin
                    Page.Text:= NPages.Text;
                end;

                if StrToInt(Page.Text)<1 then
                begin
                    Page.Text:= '1';
                end;
            end;

            Page.SelectAll;
            Page.SetFocus;

            //  Pesquisa Dados
            btnPesquisarClick(Self);
        End;
end;

procedure TuProdutos.PRVClick(Sender: TObject);
begin
    if Page.Text <> '' then
    begin
        if StrToInt(Page.Text)>=2 then
        begin
            Page.Text:= IntToStr(StrToInt(Page.Text)-1);
            btnPesquisarClick(Self);  //Somente quando existe mudanças
        end;

    end else begin
        Page.Text:= '1';
        btnPesquisarClick(Self);  //Somente quando existe mudanças
    end;
    Page.SelectAll;
end;

procedure TuProdutos.UnMarkClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

              //Cabeçalho do HTML
              //upProdutos.URL := 'produtos/zidmain?idmain=0';
              upProdutos.URL := FrmMain.BaseURL + 'produtos/zidmain?idmain=0';
              upProdutos.Command := httpPOST;
              upProdutos.Headers.Clear;
              upProdutos.Headers.AddPair('Content-Type','application/json');
              upProdutos.Headers.AddPair('Accept','application/json, text/plain, */*');
              upProdutos.PostData := '{"idmain": 0}';
              upProdutos.Execute();

          end;

    end;


begin
  Msg01.ShowDialog('Deseja desmarcar todas as etiquetas ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

procedure TuProdutos.btnExcluirClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

            try
              //Cabeçalho do HTML
              //upProdutos.URL := 'produtos/deletar/' + mIdProd.Text;
              upProdutos.URL := FrmMain.BaseURL + 'produtos/deletar/' + mIdProd.Text;
              upProdutos.Command := httpDELETE;
              upProdutos.Execute();
              WebClientDS.Delete;

            except on E: Exception do
              begin
                RS.Visible:= true;
                RS.Text:= 'Feedback Error: ['+E.ClassName+'] '+E.Message;
              end;
            end;


          end;
    end;


begin
  if  mIdProd.Text <> '' then
  begin
      Msg01.ShowDialog('Deseja excluir o Produto (' + mProduto.Text + ') ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);
  end;


end;

procedure TuProdutos.btnPesquisarClick(Sender: TObject);
var
  xURL: widestring;
  xOffset,
  xLinhasPagina: integer;
  Interm, xCampo: string;
begin
    //Exemplo interessante de autorização
    //https://api.github.com/user/repos?per_page=50  **

    Interm:= Criterio.Text;

    xLinhasPagina := 100;
    xOffset       :=  (StrToInt(Page.Text)-1) * xLinhasPagina;  //Posição do primeiro registro no banco de dados

    // Troca * por %25
    While (pos('*',Interm)>0) do
    Begin
       Interm:= Interm.Replace('*', '%25');
    End;
    // Troca * por %25

    case Campos.ItemIndex of
        0:begin
            xCampo:= 'produto';
        end;
        1:begin
            xCampo:= 'descr';
        end;
        2:begin
            xCampo:= 'gestao';
        end;
        3:begin
            xCampo:= 'idmain';
        end;
    end;

    if WebConnPages.Active = false then
    //Após digitar algo na pesquisa então fecha o NPages para não ficar pesquisando de bobeira a não ser
    //que os critrérios mudem
       begin
        try
          WebConnPages.Active:= false;

           //Quantidade de Páginas {considerando fetch='+IntToStr(xLinhasPagina)}
           //BaseURL := 'produtos/npages?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
           //BaseURL := 'produtos/npages?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
           xURL:= FrmMain.BaseURL + 'produtos/npages?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);

          //MousePointer.Cursor := -11;
          if Criterio.Text = '' then
          begin
            WebConnPages.URI := xURL;
          end else begin
            WebConnPages.URI := xURL+'&'+xCampo+'='+Interm;
            RS.Text:= WebConnPages.URI;
            // ' = %27
            // % = %25;
            // % = &#25;
            //produtos/npages?offset=0&fetch=100&gestao=0
          end;
          WebConnPages.Active:= true;
        finally

        end;
    end;



    try
      WebConn.Active:= false;

      //BaseURL := 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
      xURL:= FrmMain.BaseURL + 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);

      //MousePointer.Cursor := -11;
      if Criterio.Text = '' then
      begin
        //UTF8Encode(xURL);
        WebConn.URI := xURL;
      end else begin

        WebConn.URI := xURL+'&'+xCampo+'='+Interm;
        // ' = %27
        // % = %25;
        // % = &#37;
        //produtos?offset=0&fetch=100&gestao=0
      end;
      WebConn.Active:= true;
      RS.Text := WebConn.URI;
    finally
      //Screen.Cursor := 0;
    end;

end;

procedure TuProdutos.CamposChange(Sender: TObject);
begin
    CloseDataClick(Self);
end;

procedure TuProdutos.CloseDataClick(Sender: TObject);
begin
    WebConnPages.Active := false;
    WebDSPages.Active   := false;

    WebConn.Active      := false;
    Page.Text           := '1';
end;

procedure TuProdutos.WebClientDSBeforePost(DataSet: TDataSet);
begin
//001- Validação dos campos
    if mIdMain.Text = '' then
    begin
        ShowMessage('Quantidade de etiquetas indefinida !');
        exit;
    end;
//001- Validação dos campos




  { not fLoading then
  begin
    //Regras de validação aqui
    //    fRESTClient: IMVCRESTClient;
    Screen.Cursor:= -11;
    if memCategEQP.State = dsInsert then
      Res := fRESTClient.DataSetInsert('/api/categeqp', memCategEQP)
    else
      Res := fRESTClient.DataSetUpdate('/api/categeqp', memCategEQPidcateqp.AsString, memcategeqp);
    if not(Res.StatusCode in [200, 201]) then
    begin
      //DataSet.Refresh;    //Sem o Refresh o mesmo não muda de posição
      ShowError(Res);
      Abort;
    end
    else
    begin
      DataSet.Refresh;
      Screen.Cursor:= 0;
    end;
  end;}

end;

procedure TuProdutos.WebDBGrid1GetCellEditor(Sender: TObject; ACol,
  ARow: Integer; var AEditor: TGridCellEditor);
begin
  if ACol <> 3 then
    AEditor := TGridCellEditor.geNone;
  if ACol = 3 then
  begin
        xCol:= ACol; xRow:= ARow;
  end;

end;

procedure TuProdutos.WebDBGrid1KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
var
 xValue: string;
begin
  if xCol = 3 then
  begin
      //Somente após um Enter é que atualiza na coluna
      if (Key= VK_RETURN) then Begin
          xValue:= WebDBGrid1.Cells[xCol, xRow];

        //Montando o JASON
        xJSON:=
        '{"produto": "' + mProduto.Text + '",'+
        '"descr": "' + mDescr.Text + '",'+
        '"desenho": "' + mDesenho.Text + '",'+
        '"idmain": ' + xValue + '}';

          if mIdProd.Text <> '' then
          begin
              upProdutos.URL := FrmMain.BaseURL + 'produtos/' + mIdProd.Text;
              upProdutos.Command := httpPUT;
              upProdutos.Headers.Clear;
              upProdutos.Headers.AddPair('Content-Type','application/json');
              upProdutos.Headers.AddPair('Accept','application/json, text/plain, */*');
              upProdutos.PostData := xJSON;
              upProdutos.Execute();
          end;
      End;
  end;
end;

procedure TuProdutos.WebFormHashChange(Sender: TObject; oldURL, newURL: string);
begin
  if window.location.hash = '' then
    Close;
end;


procedure TuProdutos.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  CloseData := TButton.Create(Self);
  RS := TEdit.Create(Self);
  NPages := TDBEdit.Create(Self);
  Page := TEdit.Create(Self);
  Criterio := TEdit.Create(Self);
  Campos := TComboBox.Create(Self);
  btnPesquisar := TBitBtn.Create(Self);
  PRV := TBitBtn.Create(Self);
  NXT := TBitBtn.Create(Self);
  UnMark := TBitBtn.Create(Self);
  Msg01 := TMessageDlg.Create(Self);
  btnExcluir := TBitBtn.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  mDescr := TDBMemo.Create(Self);
  mProdEan13 := TDBEdit.Create(Self);
  mProduto := TDBEdit.Create(Self);
  mGestao := TDBEdit.Create(Self);
  mIdMain := TDBEdit.Create(Self);
  mIdProd := TDBEdit.Create(Self);
  mDesenho := TDBEdit.Create(Self);
  mObs := TDBEdit.Create(Self);
  Nav01 := TDBNavigator.Create(Self);
  mUnd := TDBEdit.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebConn := TClientConnection.Create(Self);
  WebDTS := TDataSource.Create(Self);
  WebConnPages := TClientConnection.Create(Self);
  WebDTSPages := TDataSource.Create(Self);
  WebDSPages := TClientDataSet.Create(Self);
  WebDSPagesnpages := TIntegerField.Create(Self);
  upProdutos := THttpRequest.Create(Self);
  WebClientDS := TClientDataSet.Create(Self);
  WebClientDSidprod := TIntegerField.Create(Self);
  WebClientDSgestao := TIntegerField.Create(Self);
  WebClientDSproduto := TStringField.Create(Self);
  WebClientDSdescr := TStringField.Create(Self);
  WebClientDSund := TStringField.Create(Self);
  WebClientDSdesenho := TStringField.Create(Self);
  WebClientDSprodean13 := TStringField.Create(Self);
  WebClientDSobs := TStringField.Create(Self);
  WebClientDSidmain := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  CloseData.BeforeLoadDFMValues;
  RS.BeforeLoadDFMValues;
  NPages.BeforeLoadDFMValues;
  Page.BeforeLoadDFMValues;
  Criterio.BeforeLoadDFMValues;
  Campos.BeforeLoadDFMValues;
  btnPesquisar.BeforeLoadDFMValues;
  PRV.BeforeLoadDFMValues;
  NXT.BeforeLoadDFMValues;
  UnMark.BeforeLoadDFMValues;
  Msg01.BeforeLoadDFMValues;
  btnExcluir.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  mDescr.BeforeLoadDFMValues;
  mProdEan13.BeforeLoadDFMValues;
  mProduto.BeforeLoadDFMValues;
  mGestao.BeforeLoadDFMValues;
  mIdMain.BeforeLoadDFMValues;
  mIdProd.BeforeLoadDFMValues;
  mDesenho.BeforeLoadDFMValues;
  mObs.BeforeLoadDFMValues;
  Nav01.BeforeLoadDFMValues;
  mUnd.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebConn.BeforeLoadDFMValues;
  WebDTS.BeforeLoadDFMValues;
  WebConnPages.BeforeLoadDFMValues;
  WebDTSPages.BeforeLoadDFMValues;
  WebDSPages.BeforeLoadDFMValues;
  WebDSPagesnpages.BeforeLoadDFMValues;
  upProdutos.BeforeLoadDFMValues;
  WebClientDS.BeforeLoadDFMValues;
  WebClientDSidprod.BeforeLoadDFMValues;
  WebClientDSgestao.BeforeLoadDFMValues;
  WebClientDSproduto.BeforeLoadDFMValues;
  WebClientDSdescr.BeforeLoadDFMValues;
  WebClientDSund.BeforeLoadDFMValues;
  WebClientDSdesenho.BeforeLoadDFMValues;
  WebClientDSprodean13.BeforeLoadDFMValues;
  WebClientDSobs.BeforeLoadDFMValues;
  WebClientDSidmain.BeforeLoadDFMValues;
  try
    Name := 'uProdutos';
    Width := 1100;
    Height := 554;
    Color := 16711422;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    Shadow := False;
    Visible := True;
    SetEvent(Self, 'OnHashChange', 'WebFormHashChange');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1100;
    WebPanel1.Height := 113;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := clWindow;
    WebPanel1.ChildOrder := 24;
    WebPanel1.Color := clWindow;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 17;
    WebLabel1.Width := 307;
    WebLabel1.Height := 39;
    WebLabel1.Caption := 'Listagem de Produtos';
    WebLabel1.Color := 16711422;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -32;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 607;
    WebLabel4.Top := 66;
    WebLabel4.Width := 49;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'P'#225'ginas:';
    WebLabel4.Color := 16711422;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 498;
    WebLabel3.Top := 66;
    WebLabel3.Width := 43;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'P'#225'gina:';
    WebLabel3.Color := 16711422;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    CloseData.SetParentComponent(WebPanel1);
    CloseData.Name := 'CloseData';
    CloseData.Left := 575;
    CloseData.Top := 33;
    CloseData.Width := 81;
    CloseData.Height := 25;
    CloseData.Caption := 'Close URLs';
    CloseData.ChildOrder := 6;
    CloseData.HeightPercent := 100.000000000000000000;
    CloseData.Visible := False;
    CloseData.WidthPercent := 100.000000000000000000;
    SetEvent(CloseData, Self, 'OnClick', 'CloseDataClick');
    RS.SetParentComponent(WebPanel1);
    RS.Name := 'RS';
    RS.Left := 3;
    RS.Top := 3;
    RS.Width := 653;
    RS.Height := 24;
    RS.ChildOrder := 6;
    RS.HeightPercent := 100.000000000000000000;
    RS.Required := True;
    RS.TabOrder := 1;
    RS.Visible := False;
    RS.WidthPercent := 100.000000000000000000;
    SetEvent(RS, Self, 'OnKeyUp', 'PageKeyUp');
    NPages.SetParentComponent(WebPanel1);
    NPages.Name := 'NPages';
    NPages.Left := 608;
    NPages.Top := 83;
    NPages.Width := 49;
    NPages.Height := 24;
    NPages.ChildOrder := 13;
    NPages.HeightPercent := 100.000000000000000000;
    NPages.Text := 'NPages';
    NPages.WidthPercent := 100.000000000000000000;
    NPages.DataField := 'npages';
    NPages.DataSource := WebDTSPages;
    Page.SetParentComponent(WebPanel1);
    Page.Name := 'Page';
    Page.Left := 498;
    Page.Top := 83;
    Page.Width := 49;
    Page.Height := 24;
    Page.ChildOrder := 6;
    Page.EditType := weNumeric;
    Page.HeightPercent := 100.000000000000000000;
    Page.Required := True;
    Page.TabOrder := 1;
    Page.Text := '1';
    Page.WidthPercent := 100.000000000000000000;
    SetEvent(Page, Self, 'OnKeyUp', 'PageKeyUp');
    Criterio.SetParentComponent(WebPanel1);
    Criterio.Name := 'Criterio';
    Criterio.Left := 175;
    Criterio.Top := 83;
    Criterio.Width := 138;
    Criterio.Height := 24;
    Criterio.CharCase := wecUpperCase;
    Criterio.ChildOrder := 6;
    Criterio.HeightPercent := 100.000000000000000000;
    Criterio.Required := True;
    Criterio.TabOrder := 1;
    Criterio.WidthPercent := 100.000000000000000000;
    SetEvent(Criterio, Self, 'OnChange', 'CriterioChange');
    SetEvent(Criterio, Self, 'OnKeyUp', 'CriterioKeyUp');
    Campos.SetParentComponent(WebPanel1);
    Campos.Name := 'Campos';
    Campos.Left := 24;
    Campos.Top := 83;
    Campos.Width := 145;
    Campos.Height := 24;
    Campos.HeightPercent := 100.000000000000000000;
    Campos.Text := 'Campo Produto';
    Campos.WidthPercent := 100.000000000000000000;
    SetEvent(Campos, Self, 'OnChange', 'CamposChange');
    Campos.ItemIndex := 0;
    Campos.Items.BeginUpdate;
    try
      Campos.Items.Clear;
      Campos.Items.Add('Campo Produto');
      Campos.Items.Add('Campo Descri'#231#227'o');
      Campos.Items.Add('Campo Gest'#227'o');
      Campos.Items.Add('Qtde Etiquetas');
    finally
      Campos.Items.EndUpdate;
    end;
    btnPesquisar.SetParentComponent(WebPanel1);
    btnPesquisar.Name := 'btnPesquisar';
    btnPesquisar.Left := 319;
    btnPesquisar.Top := 82;
    btnPesquisar.Width := 106;
    btnPesquisar.Height := 25;
    btnPesquisar.Caption := 'Pesquisar';
    btnPesquisar.Color := clSkyBlue;
    btnPesquisar.ElementClassName := 'btn btn-light';
    btnPesquisar.ElementFont := efCSS;
    btnPesquisar.Font.Charset := ANSI_CHARSET;
    btnPesquisar.Font.Color := clBlack;
    btnPesquisar.Font.Height := -13;
    btnPesquisar.Font.Name := 'Roboto';
    btnPesquisar.Font.Style := [];
    btnPesquisar.Glyph.LoadFromFile('Produtos.WebPanel1.btnPesquisar.Glyph.png');
    btnPesquisar.HeightStyle := ssAuto;
    btnPesquisar.HeightPercent := 100.000000000000000000;
    btnPesquisar.ParentFont := False;
    btnPesquisar.TabOrder := 3;
    btnPesquisar.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisar, Self, 'OnClick', 'btnPesquisarClick');
    PRV.SetParentComponent(WebPanel1);
    PRV.Name := 'PRV';
    PRV.Left := 553;
    PRV.Top := 82;
    PRV.Width := 24;
    PRV.Height := 25;
    PRV.Caption := '<';
    PRV.Color := clSkyBlue;
    PRV.ElementClassName := 'btn btn-light';
    PRV.ElementFont := efCSS;
    PRV.Font.Charset := ANSI_CHARSET;
    PRV.Font.Color := clWindowText;
    PRV.Font.Height := -13;
    PRV.Font.Name := 'Roboto';
    PRV.Font.Style := [];
    PRV.HeightStyle := ssAuto;
    PRV.HeightPercent := 100.000000000000000000;
    PRV.ParentFont := False;
    PRV.TabOrder := 3;
    PRV.WidthPercent := 100.000000000000000000;
    SetEvent(PRV, Self, 'OnClick', 'PRVClick');
    NXT.SetParentComponent(WebPanel1);
    NXT.Name := 'NXT';
    NXT.Left := 578;
    NXT.Top := 82;
    NXT.Width := 24;
    NXT.Height := 25;
    NXT.Caption := '>';
    NXT.Color := clSkyBlue;
    NXT.ElementClassName := 'btn btn-light';
    NXT.ElementFont := efCSS;
    NXT.Font.Charset := ANSI_CHARSET;
    NXT.Font.Color := clWindowText;
    NXT.Font.Height := -13;
    NXT.Font.Name := 'Roboto';
    NXT.Font.Style := [];
    NXT.HeightStyle := ssAuto;
    NXT.HeightPercent := 100.000000000000000000;
    NXT.ParentFont := False;
    NXT.TabOrder := 3;
    NXT.WidthPercent := 100.000000000000000000;
    SetEvent(NXT, Self, 'OnClick', 'NXTClick');
    UnMark.SetParentComponent(WebPanel1);
    UnMark.Name := 'UnMark';
    UnMark.Left := 721;
    UnMark.Top := 82;
    UnMark.Width := 106;
    UnMark.Height := 25;
    UnMark.Caption := 'Desmarcar';
    UnMark.Color := clSkyBlue;
    UnMark.ElementClassName := 'btn btn-light';
    UnMark.ElementFont := efCSS;
    UnMark.Font.Charset := ANSI_CHARSET;
    UnMark.Font.Color := clBlack;
    UnMark.Font.Height := -13;
    UnMark.Font.Name := 'Roboto';
    UnMark.Font.Style := [];
    UnMark.Glyph.LoadFromFile('Produtos.WebPanel1.UnMark.Glyph.png');
    UnMark.HeightStyle := ssAuto;
    UnMark.HeightPercent := 100.000000000000000000;
    UnMark.ParentFont := False;
    UnMark.TabOrder := 3;
    UnMark.WidthPercent := 100.000000000000000000;
    SetEvent(UnMark, Self, 'OnClick', 'UnMarkClick');
    Msg01.SetParentComponent(WebPanel1);
    Msg01.Name := 'Msg01';
    Msg01.Left := 319;
    Msg01.Top := 55;
    Msg01.Width := 24;
    Msg01.Height := 24;
    Msg01.Buttons := [];
    Msg01.Opacity := 0.200000000000000000;
    btnExcluir.SetParentComponent(WebPanel1);
    btnExcluir.Name := 'btnExcluir';
    btnExcluir.Left := 970;
    btnExcluir.Top := 82;
    btnExcluir.Width := 88;
    btnExcluir.Height := 25;
    btnExcluir.Caption := 'Excluir';
    btnExcluir.Color := 13290239;
    btnExcluir.ElementClassName := 'btn btn-light';
    btnExcluir.ElementFont := efCSS;
    btnExcluir.Font.Charset := ANSI_CHARSET;
    btnExcluir.Font.Color := clBlack;
    btnExcluir.Font.Height := -13;
    btnExcluir.Font.Name := 'Roboto';
    btnExcluir.Font.Style := [];
    btnExcluir.Glyph.LoadFromFile('Produtos.WebPanel1.btnExcluir.Glyph.png');
    btnExcluir.HeightStyle := ssAuto;
    btnExcluir.HeightPercent := 100.000000000000000000;
    btnExcluir.ParentFont := False;
    btnExcluir.TabOrder := 3;
    btnExcluir.WidthPercent := 100.000000000000000000;
    SetEvent(btnExcluir, Self, 'OnClick', 'btnExcluirClick');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 657;
    WebPanel2.Top := 113;
    WebPanel2.Width := 443;
    WebPanel2.Height := 441;
    WebPanel2.Align := alClient;
    WebPanel2.BorderColor := clWindow;
    WebPanel2.ChildOrder := 13;
    WebPanel2.Color := clWindow;
    WebPanel2.TabOrder := 1;
    WebLabel8.SetParentComponent(WebPanel2);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 63;
    WebLabel8.Top := 30;
    WebLabel8.Width := 92;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'C'#243'digo Produto:';
    WebLabel8.Color := 16711422;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel2);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 254;
    WebLabel7.Top := 30;
    WebLabel7.Width := 94;
    WebLabel7.Height := 16;
    WebLabel7.Caption := 'BarCode EAN13:';
    WebLabel7.Color := 16711422;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 63;
    WebLabel6.Top := 176;
    WebLabel6.Width := 60;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Descri'#231#227'o:';
    WebLabel6.Color := 16711422;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 63;
    WebLabel5.Top := 288;
    WebLabel5.Width := 39;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Gest'#227'o';
    WebLabel5.Color := 16711422;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 313;
    WebLabel2.Top := 288;
    WebLabel2.Width := 60;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'Qtde Etqs:';
    WebLabel2.Color := 16711422;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 63;
    WebLabel9.Top := 80;
    WebLabel9.Width := 54;
    WebLabel9.Height := 16;
    WebLabel9.Caption := 'Desenho:';
    WebLabel9.Color := 16711422;
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel2);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 63;
    WebLabel10.Top := 126;
    WebLabel10.Width := 72;
    WebLabel10.Height := 16;
    WebLabel10.Caption := 'Observa'#231#227'o:';
    WebLabel10.Color := 16711422;
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel2);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 335;
    WebLabel11.Top := 80;
    WebLabel11.Width := 51;
    WebLabel11.Height := 16;
    WebLabel11.Caption := 'Unidade:';
    WebLabel11.Color := 16711422;
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    mDescr.SetParentComponent(WebPanel2);
    mDescr.Name := 'mDescr';
    mDescr.Left := 63;
    mDescr.Top := 192;
    mDescr.Width := 338;
    mDescr.Height := 90;
    mDescr.HeightPercent := 100.000000000000000000;
    mDescr.SelLength := 0;
    mDescr.SelStart := 0;
    mDescr.TabOrder := 5;
    mDescr.WidthPercent := 100.000000000000000000;
    mDescr.DataField := 'descr';
    mDescr.DataSource := WebDTS;
    mProdEan13.SetParentComponent(WebPanel2);
    mProdEan13.Name := 'mProdEan13';
    mProdEan13.Left := 254;
    mProdEan13.Top := 46;
    mProdEan13.Width := 147;
    mProdEan13.Height := 22;
    mProdEan13.ChildOrder := 14;
    mProdEan13.EditType := weNumeric;
    mProdEan13.HeightPercent := 100.000000000000000000;
    mProdEan13.TabOrder := 1;
    mProdEan13.Text := 'mProdEan13';
    mProdEan13.WidthPercent := 100.000000000000000000;
    SetEvent(mProdEan13, Self, 'OnKeyUp', 'mProdEan13KeyUp');
    mProdEan13.DataField := 'prodean13';
    mProdEan13.DataSource := WebDTS;
    mProduto.SetParentComponent(WebPanel2);
    mProduto.Name := 'mProduto';
    mProduto.Left := 63;
    mProduto.Top := 46;
    mProduto.Width := 185;
    mProduto.Height := 22;
    mProduto.ChildOrder := 14;
    mProduto.HeightPercent := 100.000000000000000000;
    mProduto.Text := 'mProduto';
    mProduto.WidthPercent := 100.000000000000000000;
    SetEvent(mProduto, Self, 'OnKeyUp', 'mProdutoKeyUp');
    mProduto.DataField := 'produto';
    mProduto.DataSource := WebDTS;
    mGestao.SetParentComponent(WebPanel2);
    mGestao.Name := 'mGestao';
    mGestao.Left := 63;
    mGestao.Top := 304;
    mGestao.Width := 88;
    mGestao.Height := 22;
    mGestao.TabStop := False;
    mGestao.ChildOrder := 14;
    mGestao.EditType := weFloat;
    mGestao.HeightPercent := 100.000000000000000000;
    mGestao.Required := True;
    mGestao.TabOrder := 6;
    mGestao.Text := 'mGestao';
    mGestao.WidthPercent := 100.000000000000000000;
    mGestao.DataField := 'gestao';
    mGestao.DataSource := WebDTS;
    mIdMain.SetParentComponent(WebPanel2);
    mIdMain.Name := 'mIdMain';
    mIdMain.Left := 313;
    mIdMain.Top := 304;
    mIdMain.Width := 88;
    mIdMain.Height := 22;
    mIdMain.ChildOrder := 14;
    mIdMain.EditType := weFloat;
    mIdMain.HeightPercent := 100.000000000000000000;
    mIdMain.Required := True;
    mIdMain.TabOrder := 7;
    mIdMain.Text := 'mIdMain';
    mIdMain.WidthPercent := 100.000000000000000000;
    mIdMain.DataField := 'idmain';
    mIdMain.DataSource := WebDTS;
    mIdProd.SetParentComponent(WebPanel2);
    mIdProd.Name := 'mIdProd';
    mIdProd.Left := 193;
    mIdProd.Top := 304;
    mIdProd.Width := 88;
    mIdProd.Height := 22;
    mIdProd.ChildOrder := 14;
    mIdProd.EditType := weFloat;
    mIdProd.HeightPercent := 100.000000000000000000;
    mIdProd.TabOrder := 5;
    mIdProd.Text := 'mIdProd';
    mIdProd.Visible := False;
    mIdProd.WidthPercent := 100.000000000000000000;
    mIdProd.DataField := 'idprod';
    mIdProd.DataSource := WebDTS;
    mDesenho.SetParentComponent(WebPanel2);
    mDesenho.Name := 'mDesenho';
    mDesenho.Left := 63;
    mDesenho.Top := 96;
    mDesenho.Width := 266;
    mDesenho.Height := 22;
    mDesenho.ChildOrder := 14;
    mDesenho.HeightPercent := 100.000000000000000000;
    mDesenho.TabOrder := 2;
    mDesenho.Text := 'mDesenho';
    mDesenho.WidthPercent := 100.000000000000000000;
    SetEvent(mDesenho, Self, 'OnKeyUp', 'mDesenhoKeyUp');
    mDesenho.DataField := 'desenho';
    mDesenho.DataSource := WebDTS;
    mObs.SetParentComponent(WebPanel2);
    mObs.Name := 'mObs';
    mObs.Left := 63;
    mObs.Top := 142;
    mObs.Width := 338;
    mObs.Height := 22;
    mObs.ChildOrder := 14;
    mObs.HeightPercent := 100.000000000000000000;
    mObs.TabOrder := 4;
    mObs.Text := 'mObs';
    mObs.WidthPercent := 100.000000000000000000;
    mObs.DataField := 'obs';
    mObs.DataSource := WebDTS;
    Nav01.SetParentComponent(WebPanel2);
    Nav01.Name := 'Nav01';
    Nav01.Left := 64;
    Nav01.Top := 348;
    Nav01.Width := 337;
    Nav01.Height := 25;
    Nav01.DataSource := WebDTS;
    Nav01.Hints.BeginUpdate;
    try
      Nav01.Hints.Clear;
      Nav01.Hints.Add('First');
      Nav01.Hints.Add('Prior');
      Nav01.Hints.Add('Next');
      Nav01.Hints.Add('Last');
      Nav01.Hints.Add('Edit');
      Nav01.Hints.Add('Post');
      Nav01.Hints.Add('Insert');
      Nav01.Hints.Add('Delete');
      Nav01.Hints.Add('Cancel');
    finally
      Nav01.Hints.EndUpdate;
    end;
    SetEvent(Nav01, Self, 'OnPost', 'Nav01Post');
    mUnd.SetParentComponent(WebPanel2);
    mUnd.Name := 'mUnd';
    mUnd.Left := 335;
    mUnd.Top := 96;
    mUnd.Width := 66;
    mUnd.Height := 22;
    mUnd.ChildOrder := 14;
    mUnd.HeightPercent := 100.000000000000000000;
    mUnd.TabOrder := 3;
    mUnd.Text := 'mUnd';
    mUnd.WidthPercent := 100.000000000000000000;
    mUnd.DataField := 'und';
    mUnd.DataSource := WebDTS;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 113;
    WebPanel3.Width := 27;
    WebPanel3.Height := 441;
    WebPanel3.Align := alLeft;
    WebPanel3.BorderColor := clWindow;
    WebPanel3.ChildOrder := 13;
    WebPanel3.Color := clWindow;
    WebPanel3.TabOrder := 2;
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 27;
    WebPanel4.Top := 113;
    WebPanel4.Width := 630;
    WebPanel4.Height := 441;
    WebPanel4.Align := alLeft;
    WebPanel4.BorderColor := clWindow;
    WebPanel4.ChildOrder := 13;
    WebPanel4.Color := clWindow;
    WebPanel4.TabOrder := 3;
    WebDBGrid1.SetParentComponent(WebPanel4);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 0;
    WebDBGrid1.Top := 0;
    WebDBGrid1.Width := 630;
    WebDBGrid1.Height := 441;
    WebDBGrid1.Align := alClient;
    WebDBGrid1.BorderColor := clWindow;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      Alignment := taCenter;
      DataField := 'idprod';
      Editor := geNumber;
      Title := 'Id';
      Width := 62;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'produto';
      Title := 'Produto';
      Width := 180;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'descr';
      Title := 'Descri'#231#227'o';
      Width := 220;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'idmain';
      Title := '*Qtde Etqs';
      Width := 70;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'gestao';
      Title := 'Gest'#227'o';
      Width := 51;
    end;
    WebDBGrid1.DataSource := WebDTS;
    WebDBGrid1.FixedFont.Charset := DEFAULT_CHARSET;
    WebDBGrid1.FixedFont.Color := clWindowText;
    WebDBGrid1.FixedFont.Height := -12;
    WebDBGrid1.FixedFont.Name := 'Segoe UI';
    WebDBGrid1.FixedFont.Style := [];
    WebDBGrid1.FixedCols := 0;
    WebDBGrid1.Font.Charset := DEFAULT_CHARSET;
    WebDBGrid1.Font.Color := clWindowText;
    WebDBGrid1.Font.Height := -13;
    WebDBGrid1.Font.Name := 'Tahoma';
    WebDBGrid1.Font.Style := [];
    WebDBGrid1.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goEditing,goFixedRowDefAlign];
    WebDBGrid1.ParentFont := False;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid1, Self, 'OnGetCellEditor', 'WebDBGrid1GetCellEditor');
    SetEvent(WebDBGrid1, Self, 'OnKeyUp', 'WebDBGrid1KeyUp');
    WebDBGrid1.ColWidths[0] := 62;
    WebDBGrid1.ColWidths[1] := 180;
    WebDBGrid1.ColWidths[2] := 220;
    WebDBGrid1.ColWidths[3] := 70;
    WebDBGrid1.ColWidths[4] := 51;
    WebDBGrid1.RowHeights[0] := 22;
    WebDBGrid1.RowHeights[1] := 22;
    WebDBGrid1.RowHeights[2] := 22;
    WebDBGrid1.RowHeights[3] := 59;
    WebDBGrid1.RowHeights[4] := 33;
    WebConn.SetParentComponent(Self);
    WebConn.Name := 'WebConn';
    WebConn.Active := False;
    WebConn.DataNode := 'data';
    WebConn.Delimiter := ';';
    WebConn.Left := 268;
    WebConn.Top := 344;
    WebDTS.SetParentComponent(Self);
    WebDTS.Name := 'WebDTS';
    WebDTS.AutoEdit := False;
    WebDTS.DataSet := WebClientDS;
    WebDTS.Left := 456;
    WebDTS.Top := 344;
    WebConnPages.SetParentComponent(Self);
    WebConnPages.Name := 'WebConnPages';
    WebConnPages.Active := False;
    WebConnPages.DataNode := 'data';
    WebConnPages.Delimiter := ';';
    WebConnPages.URI := 'http://localhost:8083/api/produtos/npages';
    WebConnPages.Left := 268;
    WebConnPages.Top := 272;
    WebDTSPages.SetParentComponent(Self);
    WebDTSPages.Name := 'WebDTSPages';
    WebDTSPages.DataSet := WebDSPages;
    WebDTSPages.Left := 456;
    WebDTSPages.Top := 272;
    WebDSPages.SetParentComponent(Self);
    WebDSPages.Name := 'WebDSPages';
    WebDSPages.Connection := WebConnPages;
    WebDSPages.Left := 360;
    WebDSPages.Top := 272;
    WebDSPagesnpages.SetParentComponent(WebDSPages);
    WebDSPagesnpages.Name := 'WebDSPagesnpages';
    WebDSPagesnpages.FieldName := 'npages';
    upProdutos.SetParentComponent(Self);
    upProdutos.Name := 'upProdutos';
    upProdutos.Left := 731;
    upProdutos.Top := 481;
    WebClientDS.SetParentComponent(Self);
    WebClientDS.Name := 'WebClientDS';
    WebClientDS.Connection := WebConn;
    WebClientDS.BeforePost := WebClientDSBeforePost;
    WebClientDS.Left := 360;
    WebClientDS.Top := 344;
    WebClientDSidprod.SetParentComponent(WebClientDS);
    WebClientDSidprod.Name := 'WebClientDSidprod';
    WebClientDSidprod.FieldName := 'idprod';
    WebClientDSgestao.SetParentComponent(WebClientDS);
    WebClientDSgestao.Name := 'WebClientDSgestao';
    WebClientDSgestao.FieldName := 'gestao';
    WebClientDSproduto.SetParentComponent(WebClientDS);
    WebClientDSproduto.Name := 'WebClientDSproduto';
    WebClientDSproduto.FieldName := 'produto';
    WebClientDSproduto.Size := 30;
    WebClientDSdescr.SetParentComponent(WebClientDS);
    WebClientDSdescr.Name := 'WebClientDSdescr';
    WebClientDSdescr.FieldName := 'descr';
    WebClientDSdescr.Size := 100;
    WebClientDSund.SetParentComponent(WebClientDS);
    WebClientDSund.Name := 'WebClientDSund';
    WebClientDSund.FieldName := 'und';
    WebClientDSund.Size := 6;
    WebClientDSdesenho.SetParentComponent(WebClientDS);
    WebClientDSdesenho.Name := 'WebClientDSdesenho';
    WebClientDSdesenho.FieldName := 'desenho';
    WebClientDSdesenho.Size := 50;
    WebClientDSprodean13.SetParentComponent(WebClientDS);
    WebClientDSprodean13.Name := 'WebClientDSprodean13';
    WebClientDSprodean13.FieldName := 'prodean13';
    WebClientDSprodean13.Size := 13;
    WebClientDSobs.SetParentComponent(WebClientDS);
    WebClientDSobs.Name := 'WebClientDSobs';
    WebClientDSobs.FieldName := 'obs';
    WebClientDSobs.Size := 60;
    WebClientDSidmain.SetParentComponent(WebClientDS);
    WebClientDSidmain.Name := 'WebClientDSidmain';
    WebClientDSidmain.FieldName := 'idmain';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    CloseData.AfterLoadDFMValues;
    RS.AfterLoadDFMValues;
    NPages.AfterLoadDFMValues;
    Page.AfterLoadDFMValues;
    Criterio.AfterLoadDFMValues;
    Campos.AfterLoadDFMValues;
    btnPesquisar.AfterLoadDFMValues;
    PRV.AfterLoadDFMValues;
    NXT.AfterLoadDFMValues;
    UnMark.AfterLoadDFMValues;
    Msg01.AfterLoadDFMValues;
    btnExcluir.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    mDescr.AfterLoadDFMValues;
    mProdEan13.AfterLoadDFMValues;
    mProduto.AfterLoadDFMValues;
    mGestao.AfterLoadDFMValues;
    mIdMain.AfterLoadDFMValues;
    mIdProd.AfterLoadDFMValues;
    mDesenho.AfterLoadDFMValues;
    mObs.AfterLoadDFMValues;
    Nav01.AfterLoadDFMValues;
    mUnd.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebConn.AfterLoadDFMValues;
    WebDTS.AfterLoadDFMValues;
    WebConnPages.AfterLoadDFMValues;
    WebDTSPages.AfterLoadDFMValues;
    WebDSPages.AfterLoadDFMValues;
    WebDSPagesnpages.AfterLoadDFMValues;
    upProdutos.AfterLoadDFMValues;
    WebClientDS.AfterLoadDFMValues;
    WebClientDSidprod.AfterLoadDFMValues;
    WebClientDSgestao.AfterLoadDFMValues;
    WebClientDSproduto.AfterLoadDFMValues;
    WebClientDSdescr.AfterLoadDFMValues;
    WebClientDSund.AfterLoadDFMValues;
    WebClientDSdesenho.AfterLoadDFMValues;
    WebClientDSprodean13.AfterLoadDFMValues;
    WebClientDSobs.AfterLoadDFMValues;
    WebClientDSidmain.AfterLoadDFMValues;
  end;
end;

end.
